import { render, staticRenderFns } from "./InternetConnection.vue?vue&type=template&id=e80633e2&"
import script from "./InternetConnection.vue?vue&type=script&lang=js&"
export * from "./InternetConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports